import Image from 'next/image';
import classNames from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import { useTheme } from 'next-themes';

import useWindowSize from '@/hooks/useWindowSize';
import { useGetBreakPoints } from '@/constants/media';
import { ETheme } from '@/enums/theme';

import Button from '../Button/Button';

import styles from './InformationBlock.module.scss';

const InformationBlock = ({
  icon,
  content = {},
  secondary,
  noBackgroundImage = false,
  onClick = undefined,
}) => {
  const { t } = useTranslation();
  const {
    title,
    text,
    buttonText = t('common:toHomePage'),
    buttonIcon,
    fileLink,
  } = content;
  const { theme } = useTheme();
  const [windowsX] = useWindowSize();
  const { isMobile } = useGetBreakPoints();

  return (
    <div
      className={classNames([
        styles.container,
        { [styles.secondary]: secondary },
      ])}
      itemScope
      itemType='http://schema.org/Article'
    >
      {!noBackgroundImage && (
        <Image
          src={`/assets/${
            theme === ETheme.LIGHT_MODE ? 'Shapes.png' : 'ShapesDark.png'
          }`}
          layout={'fill'}
          className={styles.img}
          alt='Background image'
          title='Background image'
          loading='lazy'
        />
      )}
      {!noBackgroundImage && windowsX < isMobile && (
        <Image
          src={`/assets/${
            theme === ETheme.LIGHT_MODE
              ? 'ShapesMobile.png'
              : 'ShapesMobileDark.png'
          }`}
          layout={'fill'}
          className={styles.mobileImg}
          alt='Background image'
          title='Background image'
          loading='lazy'
        />
      )}
      <div className={styles.content}>
        {!!icon && icon}
        {!!title && (
          <div
            className={styles.title}
            dangerouslySetInnerHTML={{ __html: title }}
          />
        )}
        {!!text && (
          <div
            className={styles.text}
            dangerouslySetInnerHTML={{ __html: text }}
          />
        )}
        <Button
          onClick={onClick}
          Component={onClick ? 'button' : 'router'}
          href={fileLink ?? '/'}
          className={styles.customBtn}
          download={!!fileLink}
        >
          {!!buttonIcon && (
            <Image
              src={buttonIcon}
              alt='button icon'
              title='button icon'
              width={24}
              height={24}
            />
          )}
          {buttonText}
        </Button>
      </div>
    </div>
  );
};

export default InformationBlock;
